var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.19526 3.1953C9.67391 2.71665 10.3231 2.44775 11 2.44775C11.6769 2.44775 12.3261 2.71665 12.8047 3.1953C13.2834 3.67395 13.5523 4.32313 13.5523 5.00004C13.5523 5.67695 13.2834 6.32613 12.8047 6.80478L5.80474 13.8048C5.67971 13.9298 5.51014 14 5.33333 14H2.66667C2.29848 14 2 13.7016 2 13.3334V10.6667C2 10.4899 2.07024 10.3203 2.19526 10.1953L8.52429 3.86627C8.52572 3.86482 8.52715 3.86337 8.52859 3.86193C8.53004 3.86049 8.53148 3.85905 8.53294 3.85763L9.19526 3.1953ZM9.00002 5.27616L3.33333 10.9428V12.6667H5.05719L10.7239 7.00002L9.00002 5.27616ZM11.6667 6.05721L9.94283 4.33335L10.1381 4.13811C10.3667 3.90951 10.6767 3.78109 11 3.78109C11.3233 3.78109 11.6333 3.90951 11.8619 4.13811C12.0905 4.36671 12.2189 4.67675 12.2189 5.00004C12.2189 5.32333 12.0905 5.63337 11.8619 5.86197L11.6667 6.05721Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d0657c1e1360addfa925858ebedb3d4b.svg";
export { ForwardRef as ReactComponent };